import React, { useEffect, useState } from "react";
import { Col, ProgressBar, Row } from "react-bootstrap";
import Section from "./Section";
import RangeSlider from "react-bootstrap-range-slider";
import { gsap } from "gsap";
import { MorphSVGPlugin } from "gsap/src/MorphSVGPlugin";
import { Arrow90degDown } from 'react-bootstrap-icons';

gsap.registerPlugin(MorphSVGPlugin);

interface Props {}

const paths = [
  "M923.6,60.7c9.3,0,22.9-2.3,31,1.3c4,1.8,10.1,1.6,14.5,2.7c5.8,1.5,11.7,2.9,17.4,4.8c19.8,6.5,38.5,17.6,54.3,31.1 c15.5,13.2,28.8,28.9,38.6,46.8c10.3,18.9,15.7,39.2,20.9,59.9c5.4,21.3,6.4,44.5,6.6,66.4c0.2,22.1-1.4,45.1-6.3,66.6 c-4.7,20.6-9.6,40.6-17.3,60.4c-8.1,20.8-19.3,40.6-29.2,60.6c-9.6,19.3-18.8,38.8-28.2,58.2c-9,18.8-18,38.8-24.1,58.8 c-6.1,19.7-11.5,40.3-10.5,61.2c0.3,6.6,1,21,7.1,25.3c3,2.2,8.8,0.9,12.2,0.9c6.4-0.1,12.8-0.4,19.1-0.7 c46.2-2,92.5-1.8,138.7-1.7c45.6,0.1,91.2,0.3,136.7,3.2c22.5,1.4,45.5,2.4,67.8,5.9c20.1,3.2,39.5,8.6,55.7,21.6 c15.7,12.6,29.3,29.3,40.9,45.5c11.9,16.5,23.2,34.9,30.2,54.2c3.2,8.9,6.9,18.6,7.9,28.1c1.1,10.6-1,19.3-6.2,28.5 c-10.1,17.8-24.4,32.9-35.5,50.1c-5.6,8.7-9.7,17.3-8.1,27.9c1.6,10.6,7,20.6,12.2,29.9c9.8,17.5,21.5,34.1,30.5,52.1 c4.1,8.3,8,17.6,7.2,27c-0.9,10-6.9,19-12.7,26.8c-12.4,16.5-27.4,30.9-39.7,47.5c-5.8,7.7-11.4,16.2-11.8,26.1 c-0.3,10.6,2.4,20.9,6,30.8c7.4,20.3,17.4,40.3,23.2,61.2c6.1,21.8-0.5,39.7-13.6,57.4c-12.6,17-28.9,31-43.8,45.8 c-14.4,14.3-27.2,28.7-27,50c0.1,11,0.2,21.9,0.3,32.9c0.1,11.1,1.4,22.9-1.7,33.7c-5.5,19-21.4,36.1-34.7,50.1 c-14.5,15.2-30.6,28.8-47.8,40.8c-17.2,12.1-34.8,20.5-55.2,25.6c-20.9,5.3-42.9,7.8-64.4,9.7c-90.6,7.8-181.7,2.4-272.3-0.8 c-44.7-1.6-89.7-4.5-134.2-8.8c-10.3-1-20.5-1.4-30.8-2.2c-10.1-0.7-20.5-3.4-30.5-5.2c-21.1-3.9-42.1-7.7-63.1-11.8 c-42.8-8.3-85.8-15.9-128.6-23.9c-21.6-4-43.3-8-64.9-11.9c-10.5-1.9-21-3.9-31.5-6c-3.2-0.6-6.6-1.1-7.2-4.9 c-0.9-5.9-0.1-12.5-0.1-18.4c0.1-185.8,0.1-371.5,0.1-557.3c0-11.1,0-22.3,0-33.4c0-2.7-0.9-7.3,0.7-9.7c1.8-2.8,9.8-1.4,12.5-1.4 c9.8-0.1,19.9,0.8,29.6-1.2c9.9-2,19.1-6.7,27.5-12.1c34.1-21.9,59.7-57.8,81-91.5c23.3-36.8,43.9-75.4,62.1-114.9 c18.3-39.8,34.4-80.5,51.9-120.7c17-39.1,48.3-65.3,80.9-91.3c16.5-13.1,32.7-26.5,46.3-42.7c13.8-16.3,25-34.8,33.8-54.3 c18.1-40.2,30.1-84.3,36.2-128c6.2-44.6,12.6-89.2,15-134.2c0.4-7.5,1.6-14.6,7.4-19.9c2.4-2.2,5.4-3.9,8.5-5.1 C917,63.4,922.4,63.3,923.6,60.7C933.5,60.7,922.9,62.3,923.6,60.7z M57.2,898.2c0,113.5,0,227,0,340.5c0,46.5,0,93,0,139.6 c0,23.3,0,46.5,0,69.8c0,12.1,0,24.2,0,36.3c0,5.6,0,11.2,0,16.7c3,0.6,3.1,7.4,3.9,9.7c5.9,15.9,20.8,29.6,36.6,35.1 c9.3,3.2,18.8,3.3,28.6,3.3c11,0,22.1,0,33.1,0c46,0,92,0,138,0c19.1,0,36.9-6.9,49.6-21.7c13.4-15.7,14.6-34.7,14.6-54.5 c0-46.6,0-93.2,0-139.9c0-93.2,0-186.5,0-279.7c0-46.4,1.2-92.9-0.1-139.3c-0.5-20-7.4-38.4-23.3-51.1 c-15.4-12.4-33.6-13.3-52.5-13.4c-46.4-0.1-92.8-0.1-139.2,0c-21,0.1-42.7-2-61.1,10.1c-7.4,4.8-13.9,11-18.7,18.5 c-2.2,3.4-4,7.1-5.4,11C60.5,891.4,59.9,897.8,57.2,898.2C57.2,1099.2,58.8,898,57.2,898.2z",
  "M586.4,189.4c18.1-4.4,36.1-11,54.8-12.1c7.7-0.3,18.3-3,26.4-4c10.6-1.3,21.3-2.5,32-3.3c33.5-2,60.9,12.3,93.8,19.5 c26.4,6.2,51.6,14.6,75.3,27.8c20.9,12.4,46.4,13.4,65.6,28.3c17.6,14.4,33.8,30,48.7,47.2c12.7,15.2,24.5,30.8,31.5,49.6 c5.1,16.9,7.6,31.8,6.9,49.5c-1.9,18.9-10.3,36.8-15.3,55c-4.6,18.2-7.8,36.7-11.3,55.1c-3.6,19.6-6.6,39.3-8.8,59.1 c-2.1,22.1-3.3,43.6-1.8,65.8c0.9,9.5,1.7,20.6,7.9,28.3c2.8,2.6,7.6,1.6,10.5,1.7c5.5,0.2,10.9,0.3,16.4,0.4 c42.3,0.7,84.6,2.6,126.9,2.7c48.8,0.3,97.5,1.4,146.2,4.6c24.9,1.7,49.7,3.4,74.5,6.9c21.2,3,43.1,9.2,60.4,22.2 c16.7,12.5,30.5,29,42.6,45.8c12.1,17.3,22.1,34.6,30,54.1c3.4,8.9,6.8,18.6,7.8,28.1c1.4,9.1-1.3,20.8-6.2,28.5 c-10.9,17.4-23.8,33.2-35.5,50.1c-5.4,7.2-9.8,18.7-8.1,27.9c1.6,10.3,6.8,21.1,12.2,29.9c10.2,17.4,21,34.3,30.5,52.1 c4.3,7.6,7.9,18.2,7.2,27c-0.9,9.4-6.8,19.7-12.7,26.8c-12.9,16.2-26.9,31.3-39.7,47.5c-5.7,6.8-11.5,17-11.8,26.1 c-0.4,10,2.3,21.5,6,30.8c7.8,20.4,16.6,40.3,23.2,61.2c5.8,20.3-0.8,41.2-13.6,57.4c-12.7,17-28.8,31-43.8,45.8 c-13.5,13.1-27.8,29.9-27,50c0.1,11,0.2,21.9,0.3,32.9c0.3,11.8,0.3,22-1.7,33.7c-6,19.6-20.7,35.7-34.7,50.1 c-14.9,15-30.7,28.3-47.8,40.8c-16.6,11.7-35.4,20.9-55.2,25.6c-21.3,4.8-42.6,7.6-64.4,9.7c-90.7,7.2-181.5,2.5-272.3-0.8 c-44.8-1.7-89.6-4.6-134.2-8.8c-10.3-1-20.5-1.5-30.8-2.2c-10.2-0.8-20.5-3.2-30.5-5.2c-21.1-3.9-42.1-7.7-63.1-11.8 c-42.8-8.3-85.7-15.9-128.6-23.9c-21.6-4-43.2-8-64.9-11.9c-10.5-1.9-21-3.9-31.5-6c-3.2-0.6-6.6-1.1-7.2-4.9 c-0.9-5.9-0.1-12.5-0.1-18.4c0.1-185.8,0.1-371.5,0.1-557.3c0-11.1,0-22.3,0-33.4c0-2.7-0.9-7.3,0.7-9.7c1.8-2.8,9.8-1.4,12.5-1.4 c9.7,0.3,20,0.7,29.6-1.2c9.4-1.8,19.6-6.7,27.5-12.1c35.2-22.2,59.6-58.2,82.1-92.3c26.7-41.3,51.1-83.8,73.5-127.5 c22.8-45.8,43.4-92.6,61-140.6c14.7-37.7,37.1-68.5,63.6-98.8c7.4-8.7,18-19,19.4-31.3c1.1-12.4-8.2-21.4-15.9-29.4 c-30-25.5-68.9-40.2-104.5-55.8c-40.6-18.3-78.6-38.8-109.5-71.5c-4.5-5.1-7-10.5-0.3-16.6c2.8-2.6,7-5,11.7-7.1 C576.3,194.2,585.3,192,586.4,189.4C603.5,185.3,585.7,191,586.4,189.4z M57.2,898.2c0,113.5,0,227,0,340.5c0,46.5,0,93,0,139.6 c0,23.3,0,46.5,0,69.8c0,12.1,0,24.2,0,36.3c0,5.6,0,11.2,0,16.7c3,0.6,3.1,7.4,3.9,9.7c6.4,15.7,20.3,29.7,36.6,35.1 c8.7,3.1,19.4,3.6,28.6,3.3c11,0,22.1,0,33.1,0c46,0,92,0,138,0c18.5,0.5,37.5-7.5,49.6-21.7c13.1-14.5,14.8-35.9,14.6-54.5 c0-46.6,0-93.2,0-139.9c0-93.2,0-186.5,0-279.7c0.1-46.4,0.9-92.8-0.1-139.3c-0.4-19-7.8-39.3-23.3-51.1 c-17-10.9-32.5-13-52.5-13.4c-46.4-0.1-92.8-0.1-139.2,0c-20.1-0.2-43.6-1.9-61.1,10.1c-7.4,4.8-13.9,11-18.7,18.5 c-2.2,3.4-4,7.1-5.4,11C60.5,891.4,59.9,897.8,57.2,898.2c0,29.7-0.9,59.6,0.4,89.2C58.6,958.2,60.1,927.4,57.2,898.2z",
];

const labelsByWeek = [
  "You call those thumbs?",
  "Thumb Bum",
  "Thumb Chump",
  "Dumb Thumbs",
  "Amateur Thumb-er",
  "Sorta Sick Thumbs",
  "Sick Freakin' Thumbs",
];

const Progress = (props: Props) => {
  const [sliderValue, setSliderValue] = useState(0);
  const tl = React.useRef<gsap.core.Timeline>();

  let targetPath = React.useRef<SVGPathElement>(null);
  useEffect(() => {
    tl.current = gsap.timeline({ paused: true });
    tl.current.to(targetPath.current, {
      duration: 0.4,
      progress: 0,
      paused: false,
      morphSVG: paths[1],
    });
  }, []);

  const handleValue = (val: number) => {
    console.log(tl.current);
    // @ts-ignore
    gsap.to(tl.current, {
      duration: 0.4,
      progress: val / 6.0,
      paused: false,
    });
    setSliderValue(val);
  };

  let variantByWeek = "";
  if (sliderValue == 3) variantByWeek = "info";
  else if (sliderValue == 4) variantByWeek = "success";
  else if (sliderValue == 5) variantByWeek = "warning";
  else if (sliderValue == 6) variantByWeek = "danger";

  return (
    <Section bg={"brown"}>
      <Row>
        <Col>
          <h1 className="display-2">How it works</h1>
          <p className="display-6">A simple "six weeks to success" model</p>
          <hr className="mb-5" />
        </Col>
      </Row>
      <Row>
        <Col>
          <p className="mb-5">
            Enroll in Sick Freakin' Thumbs and see guaranteed results in only
            six weeks.
          </p>
        </Col>
      </Row>
      <Row>
        <Col>
          <div className="text-center">
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 1600 1600"
              width="200"
              height="200"
              fill="gray"
            >
              <path id="thumbpath" ref={targetPath} d={paths[0]} />
            </svg>
          </div>
          <br />
          <br />
          <p className="text-center">{labelsByWeek[sliderValue]}</p>
          <br />
          Power Level
          <ProgressBar
            variant={variantByWeek}
            animated
            now={(sliderValue / 6.0) * 100}
          />
          <br />
          <Arrow90degDown /> Slide to see what to expect 
          <br />
          <RangeSlider
            value={sliderValue}
            max={6}
            size="lg"
            tooltipLabel={(v) => ``}
            onChange={(evt) => handleValue(evt.target.valueAsNumber)}
          />
          <h3>Week {sliderValue}</h3>
        </Col>
      </Row>
    </Section>
  );
};

export default Progress;
